import { TERMS_LINKS } from '@avalara/bat-apps-shared/constants';
import { t, translate } from '@avalara/bat-apps-shared/i18n';
import { SCol, SContainer, SRow, SToasts } from '@avalara/skylab-sdk/react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { termsUrls } from '../../../../shared/lib/constants';
import { isOneWebDomainRuntime } from '../../../helpers';
import { isEsbFormTwoIncomplete } from '../../../lib/shared-signup';
import { updateProductAnalytics } from '../../../lib/side-effects/analytics';
import { createEsbAccount } from '../../../lib/side-effects/esb';
import { selectState } from '../../../selectors';
import { getEsbConfig } from '../../../selectors/esb';
import OrderSummary from '../../offer/order-summary';
import { useAbandonedCart } from '../../shared/hooks';
import AlreadyHaveAccount from '../already-have-account';
import CreateLoginFields from './fields';

const CreateLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { sharedSignup } = useSelector(selectState);
  const isFormIncomplete = isEsbFormTwoIncomplete(sharedSignup);

  useAbandonedCart();

  const esbConfig = useSelector(getEsbConfig);
  const isPaymentRequired = !esbConfig || esbConfig.isPaymentRequired;
  const buyButtonText = `${isPaymentRequired ? 'Buy now' : 'Activate'}`;

  const handleClick = () => {
    dispatch(updateProductAnalytics('buy_now'));
    dispatch(createEsbAccount(history));
  };

  return (
    <>
      <SContainer className='pad-top-xl'>
        <SRow>
          <SCol span='8'>
            <h1>{`Create an account to complete your ${isPaymentRequired ? 'purchase' : 'activation'}`}</h1>
            <div className='pad-bottom-sm'>
              <AlreadyHaveAccount />
            </div>

            <form className='pad-bottom-md'>
              <CreateLoginFields />
            </form>

            <hr className='pad-bottom-lg' />

            <button
              type='button'
              data-ref='esb.create-account-button'
              className='primary margin-right-sm'
              disabled={isFormIncomplete}
              onClick={handleClick}
            >
              {buyButtonText}
            </button>

            <p>
              {translate('client.esb.create-login.by-clicking', {
                buttonLabel: buyButtonText,
                buttonText: (chunks) => <span className='font-bold'>{chunks}</span>,
              })}
            </p>
            <br />
            <ul className='pad-left-lg'>
              <li>
                {translate('client.disclaimer.you-accept-terms-and-conditions', {
                  termsAndConditions: (
                    <a href={TERMS_LINKS.general}>{t('client.general.avalara-service-terms-and-conditions')}</a>
                  ),
                })}
              </li>
              <li>
                {translate('client.esb.create-login.cancellation-terms', {
                  cancellationUrl: termsUrls.cancellation,
                  cancellationLink: (chunks) => <a href={termsUrls.cancellation}>{chunks}</a>,
                })}
              </li>
            </ul>
          </SCol>

          {isPaymentRequired && (
            <SCol span='4'>
              <OrderSummary />
            </SCol>
          )}
        </SRow>
      </SContainer>

      {!isOneWebDomainRuntime() && <SToasts />}
    </>
  );
};

export default CreateLogin;
